export { default } from './StarRating';
export type { StarRatingProps } from './StarRating';
